











































import Vue from 'vue';
import PaginatedQuery from '../PaginatedQuery.vue';
import SingleSelect from './SingleSelect.vue';
import TooltipableOption from './TooltipableOption.vue';
export default Vue.extend({
    components: { TooltipableOption, SingleSelect, PaginatedQuery },
    props: {
        value: {
            type: [Object, String],
            default: null,
        },
        module: {
            type: String,
            required: true,
        },
        field: {
            type: String,
            required: true,
        },
        limit: {
            type: Number,
            default: 50,
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        sysFwe: {
            type: Object,
            default: null,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            required: true,
        },
    },
    data: function() {
        return {
            searchValue: '',
        };
    },
    computed: {
        url(): string {
            return `${this.$route.params.instanceId}/portal_data/${this.module}/add/fields/${this.field}`;
        },
    },
    methods: {
        searchChange(value: string) {
            this.searchValue = value;
        },
    },
});
